import { useState } from "react";

type Status = "idle" | "loading" | "success" | "error";

/**
 * 统一样式化的表单提交逻辑：蜜罐校验、防跳转提交、服务端消息解析。
 */
export default function useFormSubmit(submitAddr: string, successMessage: string) {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage(successMessage);
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const text = typeof value === "string" ? value.trim() : "";
      if (text) payload.append(key, text);
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const lowerMsg = String(serverMsg).toLowerCase();
      const isOk =
        response.ok &&
        (parsed?.code ? parsed.code === "OK" : true) &&
        !lowerMsg.includes("spam");

      if (isOk) {
        setStatus("success");
        setMessage(successMessage);
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return { status, message, submit };
}